export class GenreApiModel {
  id: string;

  name: string;

  description: string;
}
